module.exports = __webpack_public_path__ + "static/media/inquiry-success.0910d04f.png";